const india = [
    {
        id: 1,
        instrumentId: "ahkqww",
        symbol: "NIFTY",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 2,
        instrumentId: "ahkucw",
        symbol: "SENSEX",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 3,
        instrumentId: "auvwoc",
        symbol: "Gold",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 4,
        instrumentId: "auvwr7",
        symbol: "Silver",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 5,
        instrumentId: "avyo8m",
        symbol: "USD/INR",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    }
]

export const global = [
    {
        id: 1,
        instrumentId: "a3oxnm",
        symbol: "NASDAQ",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 2,
        instrumentId: "aopnp2",
        symbol: "FTSE 100",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 3,
        instrumentId: "a9j7bh",
        symbol: "Nikkei 225",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 4,
        instrumentId: "a6qja2",
        symbol: "DOW",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 5,
        instrumentId: "a33k6h",
        symbol: "S&P 500",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    }
]

export const currencies = [
    {
        id: 1,
        instrumentId: "avydm7",
        symbol: "GBP/INR",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 2,
        instrumentId: "av8w4c",
        symbol: "EUR/INR",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 3,
        instrumentId: "av3qp2",
        symbol: "CAD/INR",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 4,
        instrumentId: "auxlar",
        symbol: "AUD/INR",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 5,
        instrumentId: "avt87w",
        symbol: "SGD/INR",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    }
]

export const commodities = [
    {
        id: 1,
        instrumentId: "auvwzr",
        symbol: "US Oil WTI",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 2,
        instrumentId: "auvx6h",
        symbol: "Natural Gas",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 3,
        instrumentId: "auvwww",
        symbol: "US Copper",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 4,
        instrumentId: "auvwr7",
        symbol: "Silver",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    },
    {
        id: 5,
        instrumentId: "auvxc7",
        symbol: "Cotton",
        price: "",
        priceChange: "",
        priceChangePercent: "",
    }
]

export default india;